import React from "react";

import Text from "components/Text";

interface IMemoSectionHeader {
  title: string;
}

const MemoSectionHeader: React.FC<IMemoSectionHeader> = ({ title }) => {
  return <Text variant="h2">{title}</Text>;
};

export default MemoSectionHeader;
